import {NgModule} from "@angular/core";
import {MainComponent} from "./main.component";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {HttpModule} from "@angular/http";
import {MainRoutingModule} from "./main-routing.module";
import {FlipperModule} from "../flipper/flipper.module";

@NgModule({
  declarations: [
    MainComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpModule,
    FlipperModule,
    MainRoutingModule
  ],
  providers: [],
  exports: [MainComponent]
})
export class MainModule { }



// WEBPACK FOOTER //
// ./src/app/main/main.module.ts